import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CriticalPointTemplatePageComponent } from "./components/critical-point-template-page/critical-point-template-page.component";

const routes: Routes = [
  {
    path: "",
    component: CriticalPointTemplatePageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CriticalPointTemplateRoutingModule {}

